import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { l as launch } from './index2.js';
import { d as defineCustomElement$2 } from './pds-icon2.js';

const pdsLinkCss = ":host{--box-shadow-focus:0 0 0 1px #ffffff, 0 0 0 3px var(--pine-color-focus-ring);display:inline}:host pds-icon{-webkit-margin-start:var(--pine-dimension-2xs);margin-inline-start:var(--pine-dimension-2xs)}.pds-link{-ms-flex-align:center;align-items:center;color:var(--pine-color-text);display:-ms-inline-flexbox;display:inline-flex;font-weight:var(--pine-font-weight-medium)}.pds-link:focus-visible{-webkit-box-shadow:var(--box-shadow-focus);box-shadow:var(--box-shadow-focus);outline:none;position:relative}.pds-link--sm{font-size:var(--pine-font-size-body-xs)}.pds-link--sm pds-icon{height:var(--pine-dimension-xs);width:var(--pine-dimension-xs)}.pds-link--md{font-size:var(--pine-font-size-body-sm)}.pds-link--md pds-icon{height:var(--pine-dimension-xs);width:var(--pine-dimension-xs)}.pds-link--lg{font-size:var(--pine-font-size-body-md)}.pds-link--lg pds-icon{height:var(--pine-dimension-sm);width:var(--pine-dimension-sm)}.pds-link--plain{text-decoration:none}.pds-link--plain:hover{color:var(--pine-color-text-hover);text-decoration:underline}.pds-link--default{text-decoration:underline}.pds-link--default:hover{color:var(--pine-color-text-hover);text-decoration:none}";
const PdsLinkStyle0 = pdsLinkCss;

const PdsLink$1 = /*@__PURE__*/ proxyCustomElement(class PdsLink extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.componentId = undefined;
        this.external = false;
        this.variant = 'inline';
        this.fontSize = 'lg';
        this.href = undefined;
    }
    classNames() {
        const classNames = ['pds-link'];
        if (this.fontSize) {
            classNames.push('pds-link--' + this.fontSize);
        }
        if (this.variant) {
            classNames.push('pds-link--' + this.variant);
        }
        return classNames.join(' ');
    }
    render() {
        return (h("a", { key: 'd21ad4828be4f730d996dfa814ea8f8863053a51', class: this.classNames(), href: this.href, id: this.componentId, target: this.external ? '_blank' : undefined, part: "link" }, h("slot", { key: '7e2dd2c8f33a12ba99a7b0c6f80e263c4fc7d695' }, this.href), this.external &&
            h("pds-icon", { key: '8e1597318fb76223ae25232b9f1a814781f25409', icon: launch, size: this.fontSize })));
    }
    static get style() { return PdsLinkStyle0; }
}, [1, "pds-link", {
        "componentId": [1, "component-id"],
        "external": [4],
        "variant": [1],
        "fontSize": [1, "font-size"],
        "href": [1]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["pds-link", "pds-icon"];
    components.forEach(tagName => { switch (tagName) {
        case "pds-link":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, PdsLink$1);
            }
            break;
        case "pds-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const PdsLink = PdsLink$1;
const defineCustomElement = defineCustomElement$1;

export { PdsLink, defineCustomElement };

//# sourceMappingURL=pds-link.js.map